import { Select } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import type { Locale } from '@/api/types';
import { SUPPORTED_LOCALES } from '@/i18n/I18nContext';
import { useI18n } from '@/i18n/useI18n';

/** Manual language switch. Locale also arrives from the session; this lets the applicant override. */
export function LocaleSwitcher() {
  const { locale, setLocale, t } = useI18n();
  return (
    <Select<Locale>
      className="dr-locale"
      value={locale}
      onChange={setLocale}
      aria-label={t('locale.label')}
      suffixIcon={<GlobalOutlined aria-hidden="true" />}
      popupMatchSelectWidth={false}
      options={SUPPORTED_LOCALES.map((l) => ({ value: l, label: t(`locale.${l}`) }))}
    />
  );
}
